module.exports = __webpack_public_path__ + "img/引水.b60c94ff.jpg";